<template>
  <div class="xscontainer data-quality-management">
    <div class="mtitle">数据质量管理标准建设方案</div>
    <div class="mycontent">
      <div class="biati">
        <span class="leftbiaoti">中翰DAM</span>
        <span class="rightbiatoti">产品定位</span>
      </div>
      <p class="mparaph"> 数据中台为什么要建标签体系，分类它不香吗？在众多的数据中台的解决方案中，一个叫做“标签中心”或“标签体系”的应用，几乎成了数据中台的“标配”。乍一看，标签体系就像一个树状的分类。因此，有专家吐槽：“现在讲啥数据标签，数据类目，跟SAP Classification比真是弱爆了”。
        注：SAP Classification为SAP产品中的一个分类系统，它支持以有序的结构将特定对象（例如，文章和站点）组合在一起。它的基本功能是为各种不同类型对象的所有属性特征提供存储库。然后将相似特征的对象分组到类中（“分类”对象），以便系统可以更容易地在事务中找到它们。</p>
      <p class="mparaph"> 数据中台为什么要建标签体系，分类它不香吗？在众多的数据中台的解决方案中，一个叫做“标签中心”或“标签体系”的应用，几乎成了数据中台的“标配”。乍一看，标签体系就像一个树状的分类。因此，有专家吐槽：“现在讲啥数据标签，数据类目，跟SAP Classification比真是弱爆了”。
        注：SAP Classification为SAP产品中的一个分类系统，它支持以有序的结构将特定对象（例如，文章和站点）组合在一起。它的基本功能是为各种不同类型对象的所有属性特征提供存储库。然后将相似特征的对象分组到类中（“分类”对象），以便系统可以更容易地在事务中找到它们。</p>
      <p class="mparaph"> 数据中台为什么要建标签体系，分类它不香吗？在众多的数据中台的解决方案中，一个叫做“标签中心”或“标签体系”的应用，几乎成了数据中台的“标配”。乍一看，标签体系就像一个树状的分类。因此，有专家吐槽：“现在讲啥数据标签，数据类目，跟SAP Classification比真是弱爆了”。
        注：SAP Classification为SAP产品中的一个分类系统，它支持以有序的结构将特定对象（例如，文章和站点）组合在一起。它的基本功能是为各种不同类型对象的所有属性特征提供存储库。然后将相似特征的对象分组到类中（“分类”对象），以便系统可以更容易地在事务中找到它们。</p>
    </div>
    <div class="mycontent">
      <div class="biati">
        <span class="leftbiaoti">中翰DAM</span>
        <span class="rightbiatoti">逻辑架构</span>
      </div>
      <img src="@/assets/xxkc/luojijiagoutu.png"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataQualityManagement'
}
</script>


<style scoped>
.data-quality-management {
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.mtitle{
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 5px;
  width: 100%;
  text-align: center;
}
.biati{
  display: flex;
  justify-content: center;
  margin-top:30px;
  margin-bottom: 20px;
}
.leftbiaoti{
  background-color: #1961c6;
  height: 32px;
  line-height: 32px;
  padding: 0 18px;
  color: #ffffff;
  border-radius: 2px;
  font-weight: bold;
  font-size: 14px;
}
.rightbiatoti{
  height: 32px;
  line-height: 32px;
  padding: 0 15px;
  color: #1961c6;
  border-radius: 2px;
  font-weight: bold;
  font-size: 14px;
}
.mycontent{
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
}
.mparaph{
  margin-bottom:10px;
  letter-spacing: 1px;
  font-size: 14px;
}
.mycontent img{
  width: 100%;
  height: auto;
  margin-bottom: 50px;
}
</style>
